<template>
  <div id="kmos" @click="updateOperateState" @touchmove="updateOperateState" @mousedown="updateOperateState">
    <main-header v-if="isShowHeader" :title="title" :left-options="leftOptions" :right-options="rightOptions" :is-hide-home="isHideHome"
      :use-nav-step="useNavStep" :busiName="busiName" @left-click="leftClick" @right-click="rightClick" />

    <div :class='{"main-content": true, "show-header": isShowHeader, "autoHeight": autoHeight}'>
      <!-- 左侧导航栏 -->
      <!-- <div ref="navWrap" class="nav-left" v-if="useNavStep">
        <nav-step @scrollToBottom="scrollTo"></nav-step>
      </div> -->
      <router-view :class="useWhiteBoardStyle"></router-view>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import MainHeader from "../../components/common/header.vue";
import navStep from "../../components/common/navStep.vue";
// import allskbord from "../../device/common/input";
import log from "@/tools/logSystem/log";
import oppService from "@/service/opp-service";

export default {
  components: {
    MainHeader,
    navStep,
  },
  methods: {
    // lockHistory () {
    //   window.history.pushState(
    //     { locked: true, timestamp: Date.now() }, 
    //     "", 
    //     window.location.href
    //   );
    // },
    // 处理导航尝试
    handlePopState (event) {
      // this.lockHistory();
      // 4. 可选：显示提示信息
      // this.alert("导航功能已禁用，请使用页面内按钮操作");
      
      // 5. 强制刷新当前路由（确保URL不变）
      // this.$router.replace(this.$route.fullPath);
      // console.log("已阻止导航操作");
      // console.log(event);
      consoleLogNow("点击了浏览器的浏览器返回按钮,或者前进按钮");
    },
    updateOperateState () {
      // 刷新操作状态,点击一次就清零
    },
    //柜员登陆认证成功
    userLoginSuccess (userInfo) {
      this.userLoginInfo = userInfo;
    },
    showMsgBox (param) {
      let paramObj = Object.assign({}, param);
      this.alert({
        showMsgBox: true,
        hasMask: true,
        msg_icon: paramObj.msg_icon || "",
        messageText: paramObj.messageText || "空",
        cancelButtonText: paramObj.cancelButtonText || "取消",
        confirmButtonText: paramObj.confirmButtonText || "确定",
        confirmedAction: paramObj.callback || new Function(),
        canceledAction: paramObj.cancelback || new Function(),
        noPlayVoice: paramObj.noPlayVoice || false
      });
    },
    leftClick (event) {
      if (event == "onBackHome") {
        let that = this;
        let txt = "确定退出当前业务？";
        if (this.routePath.indexOf("firstLevelBiz") == -1 && this.routePath.indexOf("secondLevelBiz") == -1) {
          this.$store.commit(that.$types.UPDATE_LEFT_CLICK_STATE, "click");
          let is_in_busi = this.$storage.getSession("BUSI_NAME");
          if (!is_in_busi) {
            txt = "确定返回首页吗";
          }
          this.showMsgBox({
            messageText: txt,
            callback: this.leftCallBack,
            msg_icon: "question",
            cancelback: function () {
              that.$store.commit(that.$types.UPDATE_LEFT_CLICK_STATE, "cancel");
            }
          });
        } else {
          if (this.isLogin) {
            this.$router.push({ path: "/homeCustomer" });
          } else {
            this.$router.push({ path: "/home" });
          }
        }
      }
      if (event == "logout") {
        let that = this;
        that.showMsgBox({
          messageText: "确定退出当前客户？",
          msg_icon: "question",
          noPlayVoice: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          callback: function () {
            that.$router.push({ path: "/home" });
          }
        });
      }
    },
    rightClick (event) {
      // if(event == 'onCustomerAssistant') {
      if (this.$syscfg.isQSJG(this.$definecfg.QSJGDM_CONST.GUOXIN)) {
        this.rightObj.text = "已通知（5）";
        this.$store.commit(this.$types.UPDATE_NOTICE_USER, true);
        let num = 5;
        let logTimer = setInterval(() => {
          num--;
          if (num <= 0) {
            this.rightObj.text = "通知工作人员";
            this.$store.commit(this.$types.UPDATE_NOTICE_USER, false);
            clearInterval(logTimer);
          } else {
            this.rightObj.text = "已通知（" + num + "）";
          }
          this.rightObj = Object.assign({}, this.rightObj);
        }, 1000);
      } else {
        this.showMsgBox({
          messageText: this.rightObj.text.indexOf("关闭") == -1 ? "确定打开客服助手" : "确定关闭客服助手",
          callback: this.rightCallBack,
        });
      }
      // }
    },
    leftCallBack () {
      if (this.$basecfg.platform == "vtm") {
        this.$store.commit(this.$types.UPDATE_LEFT_CLICK_STATE, "confirm");
      }
      this.changeStata();
    },
    rightCallBack () {
      let that = this;
      this.startQueue = !this.startQueue;
      this.fromImageNode = false;
      if (this.startQueue) {
        this.rightObj.text = "关闭客户助手";
        this.rightObj.iconName = "";
        if (that.secInfoTim) {
          clearInterval(that.secInfoTim);
        }
        this.secondrecInfo();
      } else {
        this.rightObj.text = "客户助手";
        this.rightObj.iconName = "serviceman";
        setTimeout(function () {
          popupwin && popupwin.location.reload();
        }, 1500);
        clearInterval(that.secInfoTim);
      }
    },
    changeStata () {
      let that = this;
      let routePath = "";
      //业务办理完成后 免密业务跟资料变更业务 返回首页时候 返回到未登录首页
      if (!this.isLogin || this.$syscfg.isOpenAcctBiz(this.busiCode) || this.$syscfg.isNoPwdBiz(this.busiCode) && "V0087" != this.busiCode) {
        routePath = "/home";
      } else {
        routePath = "/homeCustomer";
      }
      /*
      //先注释掉改变流程状态的接口调用
      let bsno = this.$storage.getSession(this.$definecfg.B_SNO);
      if (bsno && this.$storage.getSession(this.$definecfg.IS_DOUBLE_RECORD) != 1 && this.routePath != "/bizComplete") {
        oppService.rejectBusiToPreAccept(bsno).then(function (data) {
          if (data.Code == "0") {
            consoleLog("业务状态变更成功");
            that.$router.push({ path: routePath });
          } else {
            that.$router.push({ path: routePath });
          }
        }).catch(function (err) {
          that.$router.push({ path: routePath });
        })
      } else {
        that.$router.push({ path: routePath });
      }

      */
      that.$router.push({ path: routePath });
    },
    //获取分屏页面传过来的数据
    secondrecInfo () {
      let that = this;
      document.getElementById("secondReceive").value = "";
      this.secInfoTim = setInterval(function () {
        let receiInfo = document.getElementById("secondReceive").value;
        if (receiInfo == "connectErr" || receiInfo == "rejectBusi" || receiInfo == "endWitness") {
          that.startQueue = false;
          that.rightObj.text = "客户助手";
          that.rightObj.iconName = "serviceman";
          if (!that.fromImageNode) {
            document.getElementById("secondReceive").value = "";
            popupwin && popupwin.location.reload();
          }
        }
      }, 1000);
    },
    banBackSpace (e) {
      let ev = e || window.event;
      //各种浏览器下获取事件对象
      let obj =
        ev.relatedTarget || ev.srcElement || ev.target || ev.currentTarget;
      //按下Backspace键
      if (ev.keyCode == 8) {
        let tagName = obj.nodeName; //标签名称
        //如果标签不是input或者textarea则阻止Backspace
        if (tagName != "INPUT" && tagName != "TEXTAREA") {
          return this.stopIt(ev);
        }
        let tagType = obj.type.toUpperCase(); //标签类型
        //input标签除了下面几种类型，全部阻止Backspace
        if (
          tagName == "INPUT" &&
          tagType != "TEXT" &&
          tagType != "TEXTAREA" &&
          tagType != "PASSWORD" &&
          tagType != "NUMBER"
        ) {
          return this.stopIt(ev);
        }
        //input或者textarea输入框如果不可编辑则阻止Backspace
        if (
          (tagName == "INPUT" || tagName == "TEXTAREA") &&
          (obj.readOnly == true || obj.disabled == true)
        ) {
          return this.stopIt(ev);
        }
      }
    },
    stopIt (ev) {
      if (ev.preventDefault) {
        //preventDefault()方法阻止元素发生默认的行为
        ev.preventDefault();
      }
      if (ev.returnValue) {
        //IE浏览器下用window.event.returnValue = false;实现阻止元素发生默认的行为
        ev.returnValue = false;
      }
      return false;
    },

    hideMsgBox () {
      this.alert({
        showMsgBox: false,
      });
    },
    scrollTo () {
      setTimeout(() => {
        this.$refs.navWrap.scrollTop = 400;
      }, 0);
    }
  },
  watch: {
    imagenodeset: function (val) {
      consoleLog("视频见证发起标志位startQueue,val", this.startQueue, val);
      if (val) {
        this.startQueue = true;
        this.fromImageNode = true;
      } else {
        this.startQueue = false;
        this.fromImageNode = false;
      }
    },
    routePath: function (val) {
      if (val == "/home" || val == "/home2") {
        // this.rightObj.text = "客户助手";
        // this.rightObj.iconName = 'serviceman';
        this.rightObj.text = "通知工作人员";
        this.rightObj.iconName = "phone";
        if (this.startQueue) {
          this.startQueue = false;
        }
        this.$storage.removeSession(this.$definecfg.B_SNO);
        this.$storage.removeSession(this.$definecfg.IS_DOUBLE_RECORD);
        this.$storage.removeSession(this.$definecfg.RECORD_USER_INFO);
        this.$storage.removeSession(this.$definecfg.BUSI_SCOPE);
        this.isuploadfile = true;
        // clearVoiceFile();
      }
    },
    busiCode: function (val, old) {
      this.busiName = this.$storage.getSession(this.$definecfg.BUSI_NAME);
    },
    loadingShow (val){
      if(val){
        this.myLoading({
          loadingText: val || "正在加载中...",
        });
      }else{
        this.myLoading({
          showLoading: false
        });
      }
    }
  },
  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState({
      route: state => state.route,
      routePath: state => state.route.path,
      imagenodeset: state => state.imagenodeset,
      isRecord: state => state.isrecord,
      isLogin: state => state.isLogin,
      busiCode: state => state.busicode,
      showUserLogin: state => state.showUserLoginDrawer,
    }),
    title () {
      return this.route.meta.name ? this.route.meta.name : "";
    },
    isShowHeader () {
      return (
        this.$route.meta.name ||
        this.$route.meta.leftOptions ||
        this.$route.meta.rightOptions ||
        this.$route.meta.useNavStep
      );
    },
    autoHeight (){
      return this.$route.meta.autoHeight;
    },
    leftOptions () {
      return this.$route.meta.leftOptions;
    },
    rightOptions () {
      // 按客户要求去掉开户类业务填写页面的客服助手
      return this.busiCode != "Z0035" &&
        this.$route.meta.rightOptions &&
        !this.fromImageNode
        ? this.rightObj
        : undefined;
    },
    isHideHome (){
      return this.$route.meta.hideHomeBtn ? true : false;
    },
    useNavStep () {
      return this.$route.meta.useNavStep;
    },
    useWhiteBoardStyle () {
      return this.$route.meta.useWhiteBoard
        ? "first-router-view router-view white-board"
        : "first-router-view router-view";
    },
    loadingShow () {
      if(this.$store.state.loadingShow === "") {
        return ;
      }
      return this.$store.state.loadingShow?true:false;
    },

  },
  data () {
    return {
      startQueue: false, //开始排队标志
      rightObj: this.$route.meta.rightOptions
        ? this.$route.meta.rightOptions
        : {},
      fromImageNode: false, //视频见证发起排队标志
      errorMsgs: [],
      showErrorMsgs: false,
      busiName: "",
      isSearchVisible: false,
      userLoginInfo: {},
      isuploadfile: false,
    };
  },
  provide () {
    //柜员认证登陆的柜员信息
    return {
      userLoginInfo: this.userLoginInfo,
      getUserLoginInfo: () => this.userLoginInfo
    };
  },
  /**实例生命周期**/
  //实例初始化之后、数据观测(data observer) 和 event/watcher 事件配置之前被调用
  beforeCreate () { },
  //实例已经创建完成之后被调用
  created () {
    this.errorMsgs = console._errMsgs;
  },
  //在挂载开始之前被调用
  beforeMount () { },
  //挂载实例
  async mounted () {
    let that = this;
    // that.keyboardControl();
    //监听导航栏的返回事件
    window.addEventListener("popstate", this.handlePopState);
    // this.lockHistory();

    //实现对字符码的截获，keypress中屏蔽了这些功能按键
    document.onkeypress = function (e) {
      that.updateOperateState();
      that.banBackSpace(e);
    };
    //对功能按键的获取
    document.onkeydown = function (e) {
      that.updateOperateState();
      that.banBackSpace(e);
    };
    //项目初始化的时候，得要把localStorage里面的字典数据清除，避免出现缓存的问题
    that.$storage.removeLocal(that.$definecfg.SYS_DICT_CACHE);
    //获取全量系统公参
    // that.$blMethod.getSysCommonParam(that);
    if(!_.isEmpty(this.$store.state.userInfo)){
      await oppService.getSysCommonParamsFromCacheObjs("FXC_LOG_MAX_ERROR_NUM");
      await oppService.getSysCommonParamsFromCacheObjs("FXC_IS_COLLECT_LOG");
    }
 
    log.initMonitor();
  },
  //数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前
  beforeUpdate () { },
  //由于数据更改导致的虚拟 DOM 重新渲染和打补丁
  updated () { },
  //keep-alive 组件激活时调用。
  activated () { },
  //keep-alive 组件停用时调用。
  deactivated () { },
  //实例销毁之前调用
  beforeDestroy () { },
  //Vue 实例销毁后调用
  destroyed () { }
};
</script>

<style lang="less">
@import "../../styles/css/normalize.css";
@import "../../styles/less/common.less";
@import "../../styles/less/pwdbox.less";
@import "~@/styles/less/variable.less";

// @import 'icons/iconfont.css';
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
  // -ms-user-select: none; /* Internet Explorer/Edge */
  // user-select: none;
}
img {
  content: "normal" !important;
}
body {
  background-attachment: fixed !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  -ms-content-zooming: none !important;
  background: #E9EBEE !important;
}

#kmos {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  color: #343434;
  .main-content {
    box-sizing: border-box;
    margin-top: 0;
    min-height: auto;
    overflow: hidden;
    display: flex;
    flex: 1;
    width: 100%;
    padding: 16px 56PX 16px;
    .first-router-view.router-view {
      flex: 1;
      margin: 0;
      width: 100%;
      // width: calc(100% - 60PX); //这个 60px 是根据 你自己的 margin 来的
      border-radius: 4px;
      box-sizing: border-box;
      > div {
        border-radius: 4px;
      }
      > .el-main:nth-child(1) {
        overflow: inherit;
      }
    }
    .nav-left {
      width: 20%;
      padding: 50px 0 100px;
      height: 90%;
      overflow-y: auto;
      overflow-x: hidden;
      -ms-overflow-style: none;
      & + .first-router-view.router-view {
        margin-right: 90px;
      }
    }
    .white-board.first-router-view {
      display: flex;
      flex-direction: column;
      width: 75%;
      // background: #fff;
      background-clip: content-box;
      .router-view {
        // background: white;
        border-radius: 4px;
        height: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        background-clip: content-box;
      }

      .customer-view {
        //客户视野区
        overflow: auto;
        box-sizing: border-box;
        width: 100%;
        position: relative;
        padding-bottom: 44px;
        -ms-overflow-style: scrollbar;
        -ms-scrollbar-face-color: #d0d2da;
        -ms-scrollbar-shadow-color: #fff;
        -ms-scrollbar-arrow-color: #fff;
        &::-webkit-scrollbar {
          display: block;
        }
      }
      .flex-column {
        height: 100%;
        display: flex;
        flex-direction: column;
      }
      //统一全局底部按钮字体 颜色设置
      .operator-footer-btn-group {
        .operator-footer-btn-group-style()
      }
    }
    // ::-webkit-scrollbar {
    //   display: none;
    // }
    .errMsgs {
      z-index: 9999;
      position: fixed;
      right: 0;
      top: 70px;
      text-align: right;
      .el-icon-info {
        color: red;
        font-size: 40px;
        margin: 10px;
      }
      .errContainer {
        text-align: left;
        background: white;
        border: 1px red solid;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        color: red;
        width: 260px;
        height: 800px;
        overflow: scroll;
        padding: 5px 0;
        .errItem {
          padding: 18px;
          border-bottom: 1px red solid;
        }
      }
    }
  }
  .autoHeight{
    flex: 0 0 auto;
  }
  .show-header {
    // margin-top: 42px;
  }
}
.message-box-wrap.customerHelper .icon-box {
  background-image: url("~@img/previous/icons/developing.svg");
}
.message-box-wrap .message-wrap{
  .content{
    //弹窗公共标题
    .alertTitle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: left;
      padding-left: 20px;
      color: #D0AA72;
      letter-spacing: 1px;
      line-height: 42px;
      height: 42px;
      font-weight: 600;
      background-image: linear-gradient(90deg, #F4E4CE 0%, #FFFFFF 100%);
      .fontsize-title-small();
    }
  }
  .operator-footer-btn-group{
    //弹窗底部公共样式
    .operator-footer-btn-group-style();
    background:white;
    box-sizing: border-box;
    // margin: 8px;
    justify-content: flex-end;
    .el-button{
      width: auto;
      min-width: 90px;
      height: 32PX;
      padding: 0;
      margin: 0 0 0 16px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/html/index/index.vue